const gForm = document.querySelector("#gform_32");
gForm?.querySelector("input[value='Zakelijk']").addEventListener("click", () => {
    gForm?.querySelectorAll(".gfield_visibility_visible").forEach((el) => {
        if (el.style.display === "none") {
            el.querySelector("input[disabled='disabled'], select[disabled='disabled']")?.removeAttribute("disabled");
        } else if (el.style.display === "block") {
            el.querySelector("input, select")?.setAttribute("disabled", "disabled");
        }
    });
});
